import { useEffect, useState } from 'react';
/** A hook that allows you to create a state that will automatically synchronize with an external value. */
export function usePropState(prop) {
    var _a = useState(prop), state = _a[0], setState = _a[1];
    useEffect(function () {
        setState(prop);
    }, [prop]);
    return [state, setState];
}
//# sourceMappingURL=usePropState.js.map